<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useMapGetter } from 'dashboard/composables/store';
import LaisGamificationSurface from 'dashboard/components-next/LaisGamificationSurface.vue';
import PostSaleAnalysisPageContent from '../components/PostSaleAnalysisPageContent.vue';
import { usePostSaleAnalysis } from '../composables/usePostSaleAnalysis';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');
const postSaleCaseId = computed(() => route.params.postSaleCaseId);
const cardId = computed(() => route.query.cardId?.toString() || '');
const analysis = usePostSaleAnalysis({
  postSaleCaseId,
  cardId,
  t,
  notify: useAlert,
});

const accountParams = computed(() => ({ accountId: route.params.accountId }));
const goBack = () =>
  router.push({
    name: 'operacao_imobiliaria_pos_venda_detalhes',
    params: {
      ...accountParams.value,
      postSaleCaseId: postSaleCaseId.value,
    },
  });
const openSale = () =>
  router.push({
    name: 'operacao_imobiliaria_vendas_detalhes',
    params: {
      ...accountParams.value,
      salesTransactionId: analysis.postSaleCase.value.property_transaction_id,
    },
  });
const openSaleDetail = detailTab =>
  router.push({
    name: 'operacao_imobiliaria_vendas_detalhes',
    params: {
      ...accountParams.value,
      salesTransactionId: analysis.postSaleCase.value.property_transaction_id,
    },
    query: { detail_tab: detailTab },
  });
const openCorrection = () =>
  router.push({
    name: 'operacao_imobiliaria_pos_venda_devolucao',
    params: {
      ...accountParams.value,
      salesTransactionId: analysis.postSaleCase.value.property_transaction_id,
    },
  });
const requestCorrection = async payload => {
  if (payload) {
    try {
      await analysis.save(payload);
    } catch {
      return;
    }
  }

  openCorrection();
};
const updateStatusAndShare = async () => {
  const postSaleCase = await analysis.advanceToAnalysis();
  if (!postSaleCase) return;

  router.push({
    name: 'operacao_imobiliaria_pos_venda_status',
    params: {
      ...accountParams.value,
      postSaleCaseId: postSaleCase.id,
    },
  });
};

onMounted(analysis.load);
</script>

<template>
  <LaisGamificationSurface
    :user-id="currentUser?.id"
    show-rail
    class="min-h-full bg-lais-bg-soft"
  >
    <PostSaleAnalysisPageContent
      :case-data="analysis.postSaleCase.value"
      :catalog="analysis.catalog.value"
      :loading="analysis.loading.value"
      :loading-case="analysis.loadingCase.value"
      :loading-transaction="analysis.loadingTransaction.value"
      :refreshing="analysis.loadingCase.value || analysis.loading.value"
      :saving="analysis.saving.value"
      :selected-topic="analysis.selectedTopic.value"
      :show-topic-form="analysis.showTopicForm.value"
      :topics="analysis.topics.value"
      :transaction="analysis.transaction.value"
      :updating-status="analysis.updatingStatus.value"
      @back="goBack"
      @close-form="analysis.closeEditor"
      @create="analysis.openCreate"
      @delete="analysis.remove"
      @edit="analysis.openEdit"
      @open-sale="openSale"
      @open-sale-detail="openSaleDetail"
      @refresh="analysis.load"
      @request-correction="requestCorrection"
      @save="analysis.save"
      @update-status="updateStatusAndShare"
    />
  </LaisGamificationSurface>
</template>
